import { ReactComponent as Pdf_svg } from "../assets/pdf.svg";
import { ReactComponent as Newo4j_svg } from "../assets/neo4j.svg";
import { ReactComponent as Db_svg } from "../assets/sql.svg";
import { ReactComponent as Image_svg } from "../assets/image.svg";
import { ReactComponent as Chat_svg } from "../assets/chatbot.svg";
import { ReactComponent as Youtube_svg } from "../assets/youtube.svg";
import { ReactComponent as Collection_svg } from "../assets/collection.svg";
import { ReactComponent as Prompt_svg } from "../assets/prompt.svg";
import { PiMicrosoftExcelLogoLight } from "react-icons/pi";

import {
  ADD_IMAGES,
  CHAT_DEFAULT,
  CHAT_WITH_EXCEL,
  CHAT_WITH_IMAGE,
  CHAT_WITH_MULTIPLE_SOURCES,
  CHAT_WITH_NEO4J,
  CHAT_WITH_RAG,
  CHAT_WITH_SQL,
  CHAT_WITH_VIDEO,
  CREATE_INDEX,
  DELETE_EXCEL,
  DELETE_IMAGE,
  DELETE_INDEX,
  DELETE_NEO4J_DB,
  DELETE_SQL_CONFIG,
  DELETE_USER_FOLDER,
  DELETE_YT_VIDEOS,
  GENERATE_PROMPT,
  GET_EXCEL,
  GET_EXCEL_DATA,
  GET_IMAGES,
  GET_INDEXES,
  GET_NEO4J_DB_NAMES,
  GET_SQL_DATA,
  GET_SQL_USERS,
  GET_USER_FOLDERS,
  GET_YT_VIDEOS,
  LOADING_SQL_DB,
  UPLOAD_EXCEL,
  UPLOAD_NEO4J_CONFIG,
  UPLOAD_SQL_CONFIG,
  UPLOAD_YOUTUBE_URL,
} from "../endpoint";

import {
  COLLECTION,
  DATABASE,
  EXCEL,
  IMAGE,
  NEO4J,
  PDF,
  PROMPT,
  VANILLA,
  YOUTUBE,
} from "./constants";

import {
  FILE_TYPES_EXCEL,
  FILE_TYPES_JSON,
  FILE_TYPES_PDF,
  FILE_TYPE_IMAGE,
} from "./allowedFileUploadTypes";
const data = [
  {
    name: VANILLA,
    icon: Chat_svg,
    color: "#666",
    showSecondary: true,
    chaturl: CHAT_DEFAULT,
    prompt_storage: "default",
    geturl: "",
    disabled: false,
    shortname: "LLM",
    datapreviewurl: "",
    mode: ["chat"],
    tooltip: "Chat with an LLM model.",
  },
  {
    name: PDF,
    icon: Pdf_svg,
    loadurl: CREATE_INDEX,
    chaturl: CHAT_WITH_RAG,
    geturl: GET_INDEXES,
    color: "rgb(235, 87, 87)",
    showSecondary: true,
    prompt_storage: "rag",
    uploadtypes: FILE_TYPES_PDF,
    deleteurl: DELETE_INDEX,
    disabled: false,
    shortname: "DOCS",
    datapreviewurl: "",
    mode: ["chat"],
    tooltip:
      "Upload documents in PDF, Word, or TXT format and get insights from them.",
  },
  {
    name: IMAGE,
    icon: Image_svg,
    color: "rgb(253, 95, 7)",
    showSecondary: false,
    loadurl: ADD_IMAGES,
    chaturl: CHAT_WITH_IMAGE,
    uploadtypes: FILE_TYPE_IMAGE,
    geturl: GET_IMAGES,
    prompt_storage: "image",
    deleteurl: DELETE_IMAGE,
    disabled: false,
    shortname: "image",
    datapreviewurl: "",
    mode: ["image", "multimodal"],
    tooltip:
      "Upload images in PNG, JPG, or JPEG format and get insights from them.",
  },
  {
    name: EXCEL,
    icon: PiMicrosoftExcelLogoLight,
    color: "rgb(253, 95, 7)",
    showSecondary: true,
    disabled: false,
    loadurl: UPLOAD_EXCEL,
    chaturl: CHAT_WITH_EXCEL,
    geturl: GET_EXCEL,
    prompt_storage: "excel",
    uploadtypes: FILE_TYPES_EXCEL,
    deleteurl: DELETE_EXCEL,
    loaddb: "",
    shortname: "Excel",
    datapreviewurl: GET_EXCEL_DATA,
    mode: ["chat", "preview"],
    tooltip:
      "Upload a small Excel file with a single sheet and ask questions related to it.",
  },
  // {
  //   name: DATABASE,
  //   icon: Db_svg,
  //   color: "rgb(27, 155, 219)",
  //   showSecondary: false,
  //   disabled: process.env?.REACT_APP_SQL_BASE_URL ? false : true,
  //   loadurl: UPLOAD_SQL_CONFIG,
  //   chaturl: CHAT_WITH_SQL,
  //   geturl: GET_SQL_USERS,
  //   prompt_storage: "sql",
  //   uploadtypes: FILE_TYPES_JSON,
  //   deleteurl: DELETE_SQL_CONFIG,
  //   loaddb: LOADING_SQL_DB,
  //   shortname: "DB",
  //   datapreviewurl: GET_SQL_DATA,
  //   mode: ["multimodal"],
  // },
  // {
  //   name: NEO4J,
  //   icon: Newo4j_svg,
  //   color: "#666",
  //   showSecondary: false,
  //   disabled: true,
  //   shortname: "neo4j",
  //   chaturl: CHAT_WITH_NEO4J,
  //   geturl: GET_NEO4J_DB_NAMES,
  //   prompt_storage: "neo4j",
  //   uploadtypes: FILE_TYPES_JSON,
  //   deleteurl: DELETE_NEO4J_DB,
  //   loadurl: UPLOAD_NEO4J_CONFIG,
  //   datapreviewurl: "",
  //   mode: ["multimodal"],
  // },
  {
    name: COLLECTION,
    icon: Collection_svg,
    color: "#FD5F07",
    showSecondary: false,
    disabled: false,
    shortname: "collection",
    chaturl: CHAT_WITH_MULTIPLE_SOURCES,
    geturl: GET_USER_FOLDERS,
    prompt_storage: "multiple",
    uploadtypes: FILE_TYPES_JSON,
    deleteurl: DELETE_USER_FOLDER,
    loadurl: UPLOAD_NEO4J_CONFIG,
    datapreviewurl: "",
    mode: ["multimodal"],
    tooltip:
      "Upload a combination of documents and images, and ask questions based on them.",
  },
  // {
  //   name: PROMPT,
  //   icon: Prompt_svg,
  //   color: "#FD5F07",
  //   showSecondary: false,
  //   disabled: false,
  //   chaturl: GENERATE_PROMPT,
  //   geturl: "",
  //   prompt_storage: "",
  //   uploadtypes: [],
  //   deleteurl: "",
  //   loadurl: "",
  //   shortname: "prompt_gen",
  //   datapreviewurl: "",
  //   mode: ["multimodal"],
  // },
  // {
  //   name: YOUTUBE,
  //   icon: Youtube_svg,
  //   color: "#CE1312",
  //   showSecondary: false,
  //   disabled: true,
  //   chaturl: CHAT_WITH_VIDEO,
  //   geturl: GET_YT_VIDEOS,
  //   prompt_storage: "video",
  //   uploadtypes: FILE_TYPES_JSON,
  //   deleteurl: DELETE_YT_VIDEOS,
  //   loadurl: UPLOAD_YOUTUBE_URL,
  //   shortname: "video",
  //   datapreviewurl: "",
  //   mode: ["multimodal"],
  // },
];

export default data;
